<template>
  <div class="currency-activation">
    <currency-activation-tabs
        :tabs="tabs"
        :active-tab="activeTabId"
        @activeTab="setActiveTab($event)"
    >
      <template #tabs-content>
        <div class="currency-activation__wrapper">
          <div class="currency-activation__wrapper-image mobile-hide">
            <img
                :src="require(`@/assets/images/currency-activation/${currentImage}.png`)"
                alt=""
            >
          </div>
          <div class="currency-activation__wrapper-content">
            <currency-activation-tabs
                v-if="currentTab?.innerTabs"
                :tabs="currentTab.innerTabs"
                :active-tab="activeTabInnerId"
                tabs-inner
                @activeTab="setActiveInnerTab($event)"
            >
              <template #tabs-content>
                <currency-activation-description
                  class="mobile-hide"
                  v-if="currentTabInner?.content"
                  :content="currentTabInner.content"
                  :active-desc="activeDescription.id"
                  @activeDescription="activeDescription = $event"
                />
              </template>
            </currency-activation-tabs>
            <currency-activation-description
                class="mobile-hide"
                v-if="currentTab?.content"
                :content="currentTab?.content"
                :active-desc="activeDescription.id"
                @activeDescription="activeDescription = $event"
            />
            <div class="currency-activation__wrapper-content-sliders mobile-show">
              <div class="slick-arrow slick-prev" :class="{'slick-disabled': firstPage}" @click="prevSlide()"></div>
              <div class="slick-arrow slick-next" :class="{'slick-disabled': lastPage}" @click="nextSlide()"></div>
              <VueSlickCarousel
                  ref="imgSlider"
                  class="img-slider"
                  :asNavFor="textSlider"
                  :focusOnSelect="true"
                  v-bind="imgSliderSettings"
              >
                <img
                    v-for="(content, idx) in currentContent" :key="idx"
                    :src="require(`@/assets/images/currency-activation/${content.img}.png`)"
                    alt=""
                >
              </VueSlickCarousel>
              <VueSlickCarousel
                  ref="textSlider"
                  class="text-slider"
                  :asNavFor="imgSlider"
                  :focusOnSelect="true"
                  @afterChange="afterPageChange"
                  v-bind="textSliderSettings"
              >
                <div
                    v-for="(content, idx) in currentContent"
                    :key="idx"
                    class="slider-text-item"
                >
                  <div class="slider-text-item__count">
                    <p>{{ idx + 1 }}</p>
                  </div>
                  <div class="slider-text-item__text">
                    <p>{{ $t(content.text) }}</p>
                  </div>
                </div>
              </VueSlickCarousel>
            </div>

<!--            <div class="mobile-show">-->
<!--              <div class="slider-control">-->
<!--                <div class="slider-control__prev" :class="{disabled: firstPage}" @click="prevSlide()">-->
<!--                  <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.0423 36.0869C31.2809 35.9279 31.4387 35.6913 31.4809 35.429C31.5231 35.1667 31.4462 34.9003 31.2673 34.6884L24.9692 27.2964L31.2673 19.9044C31.4462 19.6924 31.5231 19.426 31.4809 19.1638C31.4387 18.9015 31.2809 18.6649 31.0423 18.5059C30.9235 18.4241 30.7874 18.3642 30.6421 18.3299C30.4968 18.2956 30.3452 18.2875 30.1963 18.3061C30.0474 18.3248 29.9042 18.3697 29.7753 18.4384C29.6463 18.507 29.5341 18.5979 29.4453 18.7057L22.7874 26.5172C22.5959 26.7414 22.4922 27.015 22.4922 27.2964C22.4922 27.5778 22.5959 27.8514 22.7874 28.0755L29.4453 35.8871C29.5341 35.9949 29.6463 36.0858 29.7753 36.1544C29.9042 36.223 30.0474 36.268 30.1963 36.2866C30.3452 36.3052 30.4968 36.2972 30.6421 36.2629C30.7874 36.2285 30.9235 36.1687 31.0423 36.0869Z" fill="#636366"/>-->
<!--                  </svg>-->
<!--                </div>-->

<!--                <div class="slider-control__dots">-->
<!--                  <div v-for="(content, idx) in currentContent"-->
<!--                       :key="content.id"-->
<!--                       class="slider-control__dots-item"-->
<!--                       :class="{active: idx === currentPage}"-->
<!--                  ></div>-->
<!--                </div>-->

<!--                <div class="slider-control__next" :class="{disabled: lastPage}" @click="nextSlide()">-->
<!--                  <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.9577 36.0869C22.7191 35.9279 22.5613 35.6913 22.5191 35.429C22.4769 35.1667 22.5538 34.9003 22.7327 34.6884L29.0308 27.2964L22.7327 19.9044C22.5538 19.6924 22.4769 19.426 22.5191 19.1638C22.5613 18.9015 22.7191 18.6649 22.9577 18.5059C23.0765 18.4241 23.2126 18.3642 23.3579 18.3299C23.5032 18.2956 23.6548 18.2875 23.8037 18.3061C23.9526 18.3248 24.0958 18.3697 24.2247 18.4384C24.3537 18.507 24.4659 18.5979 24.5547 18.7057L31.2126 26.5172C31.4041 26.7414 31.5078 27.015 31.5078 27.2964C31.5078 27.5778 31.4041 27.8514 31.2126 28.0755L24.5547 35.8871C24.4659 35.9949 24.3537 36.0858 24.2247 36.1544C24.0958 36.223 23.9526 36.268 23.8037 36.2866C23.6548 36.3052 23.5032 36.2972 23.3579 36.2629C23.2126 36.2285 23.0765 36.1687 22.9577 36.0869Z" fill="#F2F2F7"/>-->
<!--                  </svg>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </template>
    </currency-activation-tabs>
  </div>
</template>

<script>
import tabs from "@/jsons/currencyActivationData.js";
import CurrencyActivationTabs from "@/components/CurrencyActivationTabs.vue";
import CurrencyActivationDescription from "@/components/CurrencyActivationDescription.vue";
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  components: {
    CurrencyActivationTabs,
    CurrencyActivationDescription,
    VueSlickCarousel
  },

  data() {
    return {
      activeTabId: null,
      activeTabInnerId: null,
      activeDescription: null,
      tabs,
      imgSlider: undefined,
      textSlider: undefined,
      imgSliderSettings: {
        "dots": false,
        "arrows": false,
        "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "fade": true,
        "slidesToShow": 1,
      },
      textSliderSettings: {
        "dots": false,
        "arrows": false,
        "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 1,
      },
      sliderPageIndex: 0
    };
  },

  computed: {
    currentTab() {
      return tabs.find((tab) => tab.id === this.activeTabId);
    },

    currentTabInner() {
      return this.currentTab.innerTabs?.find((tab) => tab.id === this.activeTabInnerId);
    },

    currentImage() {
      return this.activeDescription?.img;
    },

    currentContent() {
      if(this.currentTab.content) {
        return this.currentTab.content
      } else {
        return this.currentTabInner.content
      }
    },

    totalCount() {
      return this.currentContent.length
    },

    firstPage() {
      return this.sliderPageIndex === 0
    },

    lastPage() {
      return this.sliderPageIndex === this.totalCount - 1
    },

    currentPage() {
      return this.sliderPageIndex
    }
  },

  mounted() {
    this.activeTabId = tabs[0]?.id;
    this.activeTabInnerId = this.currentTab?.innerTabs[0].id;
    this.activeDescription = this.currentTabInner?.content[0];
    let self = this
    setTimeout(function () {
      self.imgSlider = self.$refs.imgSlider;
      self.textSlider = self.$refs.textSlider;
      self.sliderPageIndex = 0
      self.imgSlider.goTo(0)
      self.textSlider.goTo(0)
    }, 100)
  },
  methods: {
    setActiveTab(tabId) {
      this.activeTabId = tabId;
      if (this.currentTab?.innerTabs) {
        this.activeTabInnerId = this.currentTab?.innerTabs[0].id;
        this.activeDescription = this.currentTabInner?.content[0]
      } else {
        this.activeDescription = this.currentTab?.content[0];
      }
      this.currentImage = this.activeDescription?.img;

      let self = this
      setTimeout(function () {
        self.imgSlider = self.$refs.imgSlider;
        self.textSlider = self.$refs.textSlider;
        self.sliderPageIndex = 0
        self.imgSlider.goTo(0)
        self.textSlider.goTo(0)
      }, 100)
    },
    setActiveInnerTab(innerTabId) {
      this.activeTabInnerId = innerTabId;
      this.activeDescription = this.currentTabInner?.content[0];
      this.currentImage = this.activeDescription?.img;

      let self = this
      setTimeout(function () {
        self.imgSlider = self.$refs.imgSlider;
        self.textSlider = self.$refs.textSlider;
        self.sliderPageIndex = 0
        self.imgSlider.goTo(0)
        self.textSlider.goTo(0)
      }, 100)
    },
    nextSlide() {
      this.$refs.imgSlider.next()
      this.$refs.textSlider.next()
    },
    prevSlide() {
      this.$refs.imgSlider.prev()
      this.$refs.textSlider.prev()
    },
    afterPageChange(page) {
      this.sliderPageIndex = page;
    }
  }
}
</script>
